import { getPartnerTokens } from '@/api/utilities';
import { generateMelioRedirectPath } from '../utils/generateMelioRedirectPath';

export const useTaxReportLink = () => {
  const { accessToken } = getPartnerTokens();

  return generateMelioRedirectPath(accessToken, 'payment-classification');
};
